export default __webpack_public_path__ + "static/media/76.a6c62c5b.png";